import classNames from "classnames";
import React from "react";
import { SanityImageSourceExt } from "../../models/shared/SanityImageSourceExt";
import { ImagePresetCollection } from "../../utilities/image";
import { Picture } from "../Picture";

interface TestimonialProps {
  author: string;
  jobPosition: string;
  logo?: SanityImageSourceExt;
  text?: string;
}

const imagePresets: ImagePresetCollection = {
  default: {
    width: 136
  }
};

const Testimonial = ({ author, jobPosition, text = "", logo }: TestimonialProps) => (
  <div className="bg-[#197EE0] text-white rounded-lg p-8 pb-12 shadow-lg min-h-56 flex flex-col">
    <p className="text-2xl font-bold text-center justify-items-center text-inherit">
      {text}
    </p>
    <div
      className={classNames("grid items-center pt-6 mt-auto mb-0", logo && "grid-cols-2")}
    >
      <div
        className={classNames(
          "px-5 py-3",
          logo ? "border-r justify-self-end" : "text-center justify-self-center"
        )}
      >
        <p className="m-0 text-lg font-medium text-inherit">{author}</p>
        <p className="m-0 mt-1 text-xs font-light text-inherit">{jobPosition}</p>
      </div>
      {logo && (
        <div className="px-5 py-1.5">
          <Picture
            image={logo}
            presets={imagePresets}
            className="w-[8.5rem] max-h-20 overflow-hidden inline-flex"
            imgClassName="object-contain object-left"
          />
        </div>
      )}
    </div>
  </div>
);

export default Testimonial;

